export default "__VITE_ASSET__D5nuCjk8__";